import { NegativeFulfilmentStatus } from './negative-fulfilment-status';

export const TerminalStatus = [...NegativeFulfilmentStatus, 'ORDER_DELIVERED'];
